<h1 mat-dialog-title class="dialog-title">
  <mat-icon color="warn">error</mat-icon>&nbsp;Error
</h1>
<div mat-dialog-content>
  <p *ngFor="let msg of data.message">{{ msg }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClose()">OK</button>
</div>
